export default {
  data() {
    return {
      pageSize: null
    };
  },
  created() {
    this.updateScreenWidth();
    window.addEventListener('resize', this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      this.pageSize = window.innerWidth;
    }
  }
};
